<div class="docs row">
  <div class="panel col-2 pt-4">
    <ul class="list-group list-group-flush types">
      <ng-container *ngFor="let type of types">
        <li class="list-group-item bg-transparent p-0 d">
          <button
            class="tab-nav-{{ type.id }} btn text-left pl-2 rounded w-100"
            type="button"
            [class.active]="type.id === docType"
            (click)="setType(type)"
          >
            {{ type.displayValue }}
          </button>
        </li>
      </ng-container>
    </ul>
    <ul class="list-group actions mt-3 pt-3">
      <li class="list-group-item bg-transparent p-0">
        <button
          class="add-new-doc btn text-left pl-2 text-primary text-uppercase"
          type="button"
          (click)="openUploadModal()"
          *restrictTo="'UPLOAD_DOCUMENTS'"
        >
          Add new document
        </button>
      </li>
      <li class="list-group-item bg-transparent p-0">
        <button
          class="download-all btn text-left pl-2 text-primary text-uppercase"
          type="button"
          (click)="downloadAll()"
        >
          Download all
        </button>
      </li>
    </ul>
  </div>
  <div class="main col-10 py-4 pl-4" style="min-height: 400px">
    <app-dc-alert-inner></app-dc-alert-inner>
    <app-dc-loading *ngIf="loading"></app-dc-loading>
    <div class="request text-right">
      <button
        class="request-button btn rounded-pill btn-primary"
        (click)="openRequestNewModal()"
        *restrictTo="'REQUEST_DOCUMENTS'"
      >
        Request New
      </button>
    </div>
    <ng-container *ngIf="!loading && rows?.length">
      <div class="row px-3 pb-4 doc-cards">
        <ng-container
          *ngFor="let doc of lastVersions | slice: 0:2; let index = index"
        >
          <div class="doc doc-{{ index }} col-4 p-4 mr-4 rounded">
            <div class="col">
              <div class="row">
                <div class="icon mr-2">
                  <img
                    src="assets/{{ getFileType(doc.type) }}.svg"
                    class="docSVG"
                    alt="document svg"
                  />
                </div>
                <div class="col-4 pl-0 pt-1">
                  {{ doc.subtype === 'TMG' ? 'TMG' : doc.documentState }} | {{ doc.language }}
                </div>
                <div class="col pr-0 status d-flex justify-content-end">
                  <div
                    class="status-label rounded px-3 text-uppercase text-center pb-0 {{
                      getStatusLabel(doc.status)
                    }}"
                  >
                    {{ doc.status }}
                  </div>
                </div>
              </div>
            </div>
            <div class="details col mt-4 px-0 text-muted">
              <div class="small">{{ doc.documentState }}</div>
              <div class="small text-white">{{ getFileName(doc.fileUrl) }}</div>
              <div class="small">{{ doc.languageLabel }}</div>
              <div class="small">
                Created: {{ doc.createdBy }}
                {{ doc.createdAt | date: "dd/MM/yyyy" }}
              </div>
              <div class="small">
                Approved: {{ doc.approvedBy }}
                {{ doc.approvedAt | date: "dd/MM/yyyy" }}
              </div>
              <div class="actions">
                <app-document-menu
                  [status]="doc.status"
                  [doc]="doc"
                  [rows]="rows"
                  (doAction)="doAction(doc, $event)"
                >
                </app-document-menu>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <app-dc-table
        #table
        class="no-footer rounded doc-table"
        [columns]="columns"
        [rows]="rows"
        [messages]="messages"
        [sort]="sortOrder"
        (action)="doAction($event.row, $event.type)"
      ></app-dc-table>
    </ng-container>
    <ng-container *ngIf="!loading && rows?.length === 0">
      <div class="noDocsContainer">
        <div>
          <img
            src="assets/doument-magnifying-glass.svg"
            class="docSearchIcon"
          />
          <p class="noDocsText">No Documents Available</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template ngx-datatable-cell-template #subtype let-value="value">
  {{ value | documentType | valueOrDash }}
</ng-template>
